export const GUEST = 0
export const COMMERCIAL = 1
export const ANALYST = 2
export const OPERATIONS = 2
export const SUPERUSER = 99
